import axios from 'axios';
import { constants } from '../../constants';
export const loginRequest = async ({ username, password, usertype }) => {
  try {
    const response = await axios.post(`${constants.API_BASE}/admin/login`, {
      username,
      password,
      usertype,
    });
  
    return response.data; 
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Login failed. Please check your credentials and try again.';
    throw new Error(message);
  }
  };
  
export const changePassword = async ({
  current_password,
  new_password,
  new_password_confirmation,
  user_type,
}) => {
  try {
  const tokenData = JSON.parse(localStorage.getItem('token'));
  const token = tokenData?.value;
       const response = await axios.post(
      `${constants.API_BASE}/admin/change-password`,
      {
        current_password,
        new_password,
        new_password_confirmation,
        user_type,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to change password. Please try again.';
    throw new Error(message);
  }
  };
  
